<template>
    <div
        v-if="origin"
        style="text-align: center;"
    >
        <i
            class="fa fa-arrows-v"
            style="font-size: 30px; margin: 5px;"
        />
    </div>
    <div
        v-else
        ref="contentWrapper"
        style="height: 100%;"
        :style="{'marginLeft': data.style ? data.style.marginLeft: '0px', 'marginRight': data.style ? data.style.marginRight : '0px', 'marginTop': data.style ? data.style.marginTop: '0px', 'marginBottom': data.style ? data.style.marginBottom: '0px', 'backgroundColor': data.style ? data.style.backgroundColor : 'transparent'}"
        @mousedown="triggerFocus($event, data.id)"
    >
        <block-styles
            v-if="(isEdited || isForced)"
            :data="data"
            :wrapper="$refs.contentWrapper"
            @change="updateStyles"
        />
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue'
    import BlockStyles from './BlockStyles.vue'

    export default {
        name: 'Spacer',
        components: {'block-styles': BlockStyles},
        mixins: [ComponentMixin],
        props: {
            'bindedStyles': {
                type: Array,
                default: function () { return [
                    'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'backgroundColor' 
                ] }
            },
        },
    }
</script>
